__turbopack_context__.v({
  "alternateColumn": "ProductComparison-module-scss-module__hl6A0G__alternateColumn",
  "comparisonContainer": "ProductComparison-module-scss-module__hl6A0G__comparisonContainer",
  "comparisonItemField": "ProductComparison-module-scss-module__hl6A0G__comparisonItemField",
  "comparisonItemFieldLink": "ProductComparison-module-scss-module__hl6A0G__comparisonItemFieldLink",
  "comparisonItemFieldPrice": "ProductComparison-module-scss-module__hl6A0G__comparisonItemFieldPrice",
  "comparisonTable": "ProductComparison-module-scss-module__hl6A0G__comparisonTable",
  "fieldLabel": "ProductComparison-module-scss-module__hl6A0G__fieldLabel",
  "fieldLabelColumn": "ProductComparison-module-scss-module__hl6A0G__fieldLabelColumn",
  "headerLabel": "ProductComparison-module-scss-module__hl6A0G__headerLabel",
  "headerRow": "ProductComparison-module-scss-module__hl6A0G__headerRow",
  "image": "ProductComparison-module-scss-module__hl6A0G__image",
  "imageHeader": "ProductComparison-module-scss-module__hl6A0G__imageHeader",
  "productColumn": "ProductComparison-module-scss-module__hl6A0G__productColumn",
  "reviewTotal": "ProductComparison-module-scss-module__hl6A0G__reviewTotal",
  "srOnly": "ProductComparison-module-scss-module__hl6A0G__srOnly",
});
